import React from 'react';
import TableC from '../../../basicElement/TableC';
import renderEnhancer from '../../../shared/renderEnhancer';
import cellRenderEnhancer from '../../../shared/cellRenderEnhancer';

function Employees({
    data,
    employees,
    processList,
    showEmployeeDetail,
    showAssignEmployee,
    pagination,
    handleTableChange
}) {
    const getColumns = () => {
        const columns = [{
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            fixed: 'left',
            width: 80,
            render: (text, record) => <a onClick={() => showEmployeeDetail(record.userId, record.employeeCode, record.userName)}>{record.employeeCode}</a>,
        }, {
            title: '姓名',
            dataIndex: 'employeeName',
            key: 'employeeName',
            fixed: 'left',
            width: 80,
        }, {
            title: '职位',
            dataIndex: 'positionName',
            key: 'positionName',
            width: 120,
        }, {
            title: '语言水平',
            dataIndex: 'languageName',
            key: 'languageName',
            width: 200,
        }, {
            title: '相关证书',
            dataIndex: 'licencesCertificatesName',
            key: 'licencesCertificatesName',
            width: 200,
        }, {
            title: '是否参与过该类项目',
            dataIndex: 'vitaeClinicalExperience',
            key: 'vitaeClinicalExperience',
            width: 80,
            render: text => text ? text == '1' ? '是' : '否' : ''
        }, {
            title: '休假情况',
            dataIndex: 'vacationValue',
            key: 'vacationValue',
            width: 200,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const { vacationValue } = record;
                        const list = vacationValue ? vacationValue.split(','):[]
                        if ((list || []).length > 1) {
                            return (
                                <div>
                                    {
                                        list.map((value,index) => (
                                            <div key={index}>
                                                {value} 
                                            </div>
                                        ))
                                    }
                                </div>
                            );
                        }
                    }
                })(text => text ? text.split(',')[0] : '')
            ),
        }];

        (data || []).forEach((fte, i) => {
            const time = `${fte.year}.${fte.month}`;
            columns.push({
                title: time,
                children: [{
                    title: '已分配',
                    dataIndex: `${time}_fte`,
                    key: `${time}_fte`,
                    width: 60,
                }, {
                    title: '预分配',
                    dataIndex: `${time}_pfte`,
                    key: `${time}_pfte`,
                    width: 60,
                }],
            });
        });

        columns.push({
            title: '操作',
            key: 'operation',
            fixed: 'right',
            width: 100,
            render: (text, record) => {
                const hasProcess = (processList || []).some(i => i.userId == record.userId);
                return (
                    hasProcess ?
                        <a disabled={true}>已分派</a>
                    :
                        <a onClick={() => showAssignEmployee(record)}>分派</a>
                )
            }
        });

        return columns;
    }

    const getDataSource = () => {
        return (employees || []).map(employee=> {
            const { fteList, vacationValue } = employee;
            if (vacationValue && vacationValue.includes(',')) {
                employee.vacationValue = vacationValue;
            }

            (fteList || []).forEach(fte => {
                const time = `${fte.year}.${fte.month}`;
                employee[`${time}_fte`] = fte.fte ? fte.fte.toFixed(2) : 0;
                employee[`${time}_pfte`] = fte.pfte ? fte.pfte.toFixed(2) : 0;
            });
            return employee;
        });
    }

    return (
        <TableC
            columns={getColumns()}
            data={getDataSource()}
            className="employees"
            pagination={pagination}
            rowKey="userId"
            reRenderTime={400}
            onChange={handleTableChange}
        />
    );
}

export default Employees;


// WEBPACK FOOTER //
// ./src/components/user/require/tables/Employees.js